import TableCustomHead from "@ui/tableCustom/head/TableCustomHead";
import TbodyCustom from "@ui/tableCustom/view/ui/tbodyCustom/TbodyCustom";
import React, {ReactNode} from 'react'
import {HeadColumns, mapperColumnCbType, MapperRowCbType} from "@ui/tableCustom/types/table";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {IQueryParamsContext} from "@hooks/query/types/queryParams";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {useMedia} from "@hooks/ui/useMedia";
import TableCustomUiComponent from "@ui/tableCustom/containers/list/view/TableCustomUiComponent";


interface IProps<T> {
    data: T[],
    mapperRowCb: MapperRowCbType<T>,
    fullColumns: IColumnItem<T>[],
    params: IQueryParamsContext<T>,
    exportParams: IExportParamsContext<T>,
    exportMutate: IExportMutateContext<T>,
    mapperColumnCb?: mapperColumnCbType<T>,
    headColumns?: HeadColumns<T>,
    stickyHeader?: boolean,
    fullScreenMode?: boolean,
    maxHeightScreen?: string,
    lastTableRow?: ReactNode
}

function TableCustomListNormal<T>({
                                      data,
                                      mapperRowCb,
                                      fullColumns,
                                      exportMutate,
                                      exportParams,
                                      mapperColumnCb,
                                      params,
                                      headColumns,
                                      stickyHeader,
                                      fullScreenMode,
                                      maxHeightScreen,
                                      lastTableRow,
                                  }: IProps<T>) {
    const {isDesktop} = useMedia()
    const {exportMode, exportDataFromAllPage} = exportParams;
    const {onChangeExportRow, hasExportRow, rerenderAllRowsDeps} = exportMutate;

    const list = React.useMemo(() => {
        if (!data) {
            return
        }
        return data.map((item, index) => {
            return mapperRowCb({
                content: item,
                index,
                exportFeaturesProps: {
                    exportMode, hasExportRow, onChangeExportRow, exportDataFromAllPage, rerenderAllRowsDeps
                },
            })
        })

    }, [data, fullColumns, headColumns, mapperRowCb, exportMode, rerenderAllRowsDeps, exportDataFromAllPage])


    return (
        <TableCustomUiComponent
            stickyHeader={stickyHeader}
            maxHeightScreen={maxHeightScreen}
        >
            <TableCustomHead
                <T>
                columns={headColumns ?? fullColumns}
                exportMutate={exportMutate}
                exportParams={exportParams}
                mapperColumnCb={mapperColumnCb}
                params={params}
            />
            <TbodyCustom>
                {list}
                {lastTableRow && lastTableRow}
            </TbodyCustom>
        </TableCustomUiComponent>
    );
}


export default TableCustomListNormal;
